import Vue from 'vue';
import wx from 'weixin-js-sdk'//微信分享sdk
import { Toast } from 'vant';
import { getJdk } from "@/api/api.js";


//暴露插件
export function wechatShare(shareDate) {
  return new Promise(async function(resolve, reject) {
    try {
      let isWechat = navigator.userAgent.indexOf('MicroMessenger') > -1
      if(!isWechat) {
        //return resolve('您目前所处的并不是微信内置浏览器')
      }
      console.log(document.title);
      //设置默认的分享标题、描述、网页、图片，以及分享成功后的回调
      let defaultData = {
        title: '',
        content: '',
        url: document.location.href,
        logo: '',
        success: function (res) {}
      }
      console.log("进入分享：",defaultData)
      //shareDate是你重置的分享标题等等
      let data = { ...defaultData, ...shareDate }
      //等待后台返回签名
      let ret = await act();
      console.log('后台返回签名结果',ret);
      if(ret.code!=1){
        reject(ret);
      }
      //后台返回成功后，配置微信的
      let newRest = Object.assign({
        debug: ret.data.debug,
        jsApiList: ret.data.jsApiList,
        openTagList: ['wx-open-launch-weapp'], // 获取开放标签权限
      }, {
        appId: ret.data.appId, //公众号的唯一标识
        timestamp: ret.data.timestamp, //接口返回签名的时间戳
        nonceStr: ret.data.nonceStr, //接口返回签名的随机串
        signature: ret.data.signature //接口返回签名
      })
      wx.config(newRest)
      console.log(newRest)
      //处理验证成功后的信息
      wx.ready(function () {
        console.log('ready')
        wx.onMenuShareTimeline({ //分享到朋友圈
          title: data.title,
          desc: data.content,
          link: data.url,
          imgUrl: data.logo,
          dataUrl: '',
          success: data.success,
          cancel: function () {}
        })
        wx.onMenuShareAppMessage({ //分享给朋友
          title: data.title,
          desc: data.content,
          link: data.url,
          imgUrl: data.logo,
          dataUrl: '',
          success: data.success,
          cancel: function () {}
        })
      })
    } catch (error) {
      reject('分享失败--->',error) //处理验证失败后的结果
    }
  })
}

export function wechatScanQRCode() {
  return new Promise(async function(resolve, reject) {
    try {
      let isWechat = navigator.userAgent.indexOf('MicroMessenger') > -1
      if(!isWechat) {
        //return resolve('您目前所处的并不是微信内置浏览器')
      }
      //等待后台返回签名
      let ret = await act();
      if(ret.code!=1){
        reject(ret.msg);
      }
      //后台返回成功后，配置微信的
      let newRest = Object.assign({
        debug: ret.data.debug,
        jsApiList: ret.data.jsApiList,
        openTagList: ['wx-open-launch-weapp'], // 获取开放标签权限
      }, {
        appId: ret.data.appId, //公众号的唯一标识
        timestamp: ret.data.timestamp, //接口返回签名的时间戳
        nonceStr: ret.data.nonceStr, //接口返回签名的随机串
        signature: ret.data.signature //接口返回签名
      })
      wx.config(newRest)
      console.log(newRest)
      //处理验证成功后的信息
      wx.ready(function () {
        console.log('ready')
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
          success: function(res) {
            sessionStorage.setItem('write_result',res.resultStr)
          },
        })
      })
    } catch (error) {
      reject(error) //处理验证失败后的结果
    }
  })
}

export function wechatGetLocation() {
  return new Promise(async function(resolve, reject) {
    try {
      let isWechat = navigator.userAgent.indexOf('MicroMessenger') > -1
      if(!isWechat) {
        //return resolve('您目前所处的并不是微信内置浏览器')
      }
      //等待后台返回签名
      let ret = await act();
      if(ret.code!=1){
        reject(ret.msg);
      }
      //后台返回成功后，配置微信的
      let newRest = Object.assign({
        debug: ret.data.debug,
        jsApiList: ret.data.jsApiList,
        openTagList: ['wx-open-launch-weapp'], // 获取开放标签权限
      }, {
        appId: ret.data.appId, //公众号的唯一标识
        timestamp: ret.data.timestamp, //接口返回签名的时间戳
        nonceStr: ret.data.nonceStr, //接口返回签名的随机串
        signature: ret.data.signature //接口返回签名
      })
      wx.config(newRest)
      console.log(newRest)
      //处理验证成功后的信息
      wx.ready(function () {
        console.log('ready')
        wx.getLocation({
          type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function (res) {
            var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            var speed = res.speed; // 速度，以米/每秒计
            var accuracy = res.accuracy; // 位置精度
            sessionStorage.setItem('latitude',latitude)
            sessionStorage.setItem('longitude',longitude)
          }
        })
      })
    } catch (error) {
      reject(error) //处理验证失败后的结果
    }
  })
}
//异步接口获取签名
function act() {
  return new Promise((resolve, reject) => {
    getJdk({
      url: encodeURIComponent(window.location.href.split('#')[0])
    }).then(res => {
      resolve(res)
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/wxConfig.js